import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { formatPrice, constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'

import messages from './messages'
import s from './OldUpgradeSubscriptionModal.scss'


class OldUpgradeSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      placement: PropTypes.string,
    }),
  }

  static defaultProps = {
    name: constants.modals.OldUpgradeSubscription,
    data: {},
  }

  constructor() {
    super()

    this.state = {
      completed: false,
      message: '',
    }
  }

  close = () => {
    const { name } = this.props
    actions.models.modals.close(name)
  }

  order = () => {
    const { data: { size, placement } } = this.props

    actions.models.subscription.upgradePlan({ size, placement })
      .then((data) => {
        this.setState({
          completed: true,
          message: data.message,
        })
      }, ({ resData: { text } }) => {
        let parsedText

        try {
          parsedText = JSON.parse(text)
        }
        catch (e) {
          parsedText = {}
        }

        const { message } = parsedText

        this.setState({
          completed: true,
          message,
        })
      })
  }

  render() {
    const { name, data: { title, price } } = this.props
    const { completed, message } = this.state

    let headingTitle = title
    let completedMessage = ''

    if (completed) {
      [ headingTitle, completedMessage ] = message.split('.')
    }

    return (
      <Modal
        className={s.upgradeSubscription}
        name={name}
        title={headingTitle}
      >
        {
          completed ? (
            <div>
              {completedMessage}
              <ModalFooter>
                <Button
                  brand
                  title={messages.close}
                  onClick={this.close}
                />
              </ModalFooter>
            </div>
          ) : (
            <div className={s.box}>
              <div className={s.price}>{formatPrice(price, true)}</div>
              <FormattedMessage tag="div" {...messages.paymentToUpgrade} />
              <div className={s.shipping}>
                <FormattedMessage tag="div" {...messages.freeShipping} />
                <FormattedMessage tag="div" {...messages.tax} />
              </div>
              <ModalFooter>
                <Button
                  className={s.submitButton}
                  brand
                  fullWidth
                  noPadding
                  title={messages.orderButton}
                  onClick={this.order}
                />
              </ModalFooter>
            </div>
          )
        }
      </Modal>
    )
  }
}


export default connect({
  nextShippingDate: 'models.subscription.nextShippingDate',
})(OldUpgradeSubscriptionModal)
